module.exports = __webpack_public_path__ + "img/clock-six-thirty.32bc03fe.svg";